(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__rbCardInit) return;
  window.__rbCardInit = true;

  function sibs(card) {
    var el = card.querySelector('[data-rb-sibs]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function buildSizes(card, s) {
    var wrap = card.querySelector('[data-rb-sizes]');
    wrap.innerHTML = '';
    card.removeAttribute('data-variant');
    if (s.soon) { wrap.hidden = true; return; }
    if (s.single) {
      wrap.hidden = true;
      if (s.variants[0]) card.setAttribute('data-variant', s.variants[0].id);
      return;
    }
    wrap.hidden = false;
    s.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rb-card__size';
      b.setAttribute('data-rb-size', v.id);
      b.textContent = v.t;
      if (!v.a) b.disabled = true;
      wrap.appendChild(b);
    });
  }

  function applySib(card, s, idx) {
    card.setAttribute('data-soon', s.soon ? 'true' : 'false');
    card.querySelectorAll('[data-rb-link]').forEach(function (a) { a.href = s.url; });
    var media = card.querySelector('.rb-card__media');
    if (media) media.setAttribute('aria-label', s.full);
    var img = card.querySelector('[data-rb-img]');
    if (img && s.img) {
      img.removeAttribute('loading');
      img.srcset = s.img400 + ' 400w, ' + s.img + ' 800w';
      img.src = s.img;
      if (s.w) { img.width = s.w; img.height = s.h; }
    }
    var alt = card.querySelector('[data-rb-alt]');
    if (alt) { if (s.alt) { alt.src = s.alt; alt.hidden = false; } else { alt.hidden = true; } }
    var title = card.querySelector('.rb-card__title a');
    if (title) title.textContent = s.title;
    var colour = card.querySelector('[data-rb-colour]');
    if (colour) colour.textContent = s.colour;
    var price = card.querySelector('[data-rb-price]');
    if (price) price.innerHTML = s.price + (s.was ? '<span class="rb-card__was">' + s.was + '</span>' : '');
    var flag = card.querySelector('[data-rb-flag]');
    if (flag) {
      if (s.soon) {
        flag.textContent = 'Coming soon';
        flag.className = 'rb-card__flag rb-card__flag--soon';
        flag.hidden = false;
      } else {
        flag.textContent = 'Sold out';
        flag.className = 'rb-card__flag rb-card__flag--out';
        flag.hidden = s.available;
      }
    }
    card.querySelectorAll('[data-rb-swatch]').forEach(function (b) {
      var on = String(b.getAttribute('data-rb-swatch')) === String(idx);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    buildSizes(card, s);
    var add = card.querySelector('[data-rb-add]');
    add.classList.toggle('is-soon', !!s.soon);
    if (s.soon) {
      add.disabled = false;
      add.textContent = 'Register interest';
    } else {
      add.disabled = !s.available;
      add.textContent = s.available ? 'Quick add +' : 'Sold out';
    }
  }

  function openCart() {
    if (typeof window.upcartRefreshCart === 'function') { try { window.upcartRefreshCart(); } catch (e) {} }
    if (typeof window.upcartOpenCart === 'function') { try { window.upcartOpenCart(); return; } catch (e) {} }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    if (!document.querySelector('upcart-root, #upCart, [id*="upcart" i]')) window.location.href = '/cart';
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-rb-swatch]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-rb-card]');
      var list = sibs(card);
      var i = parseInt(sw.getAttribute('data-rb-swatch'), 10);
      if (list[i]) applySib(card, list[i], i);
      return;
    }

    var size = e.target.closest('[data-rb-size]');
    if (size && !size.disabled) {
      var c = size.closest('[data-rb-card]');
      c.querySelectorAll('[data-rb-size]').forEach(function (b) { b.classList.remove('is-selected'); });
      size.classList.add('is-selected');
      c.setAttribute('data-variant', size.getAttribute('data-rb-size'));
      var btn = c.querySelector('[data-rb-add]');
      if (!btn.disabled) btn.textContent = 'Quick add +';
      return;
    }

    var add = e.target.closest('[data-rb-add]');
    if (add && !add.disabled) {
      var card2 = add.closest('[data-rb-card]');

      if (card2.getAttribute('data-soon') === 'true') {
        var link = card2.querySelector('[data-rb-link]');
        if (link) window.location.href = link.href;
        return;
      }

      var id = card2.getAttribute('data-variant');
      if (!id) {
        add.textContent = 'Select a size';
        add.classList.remove('is-prompt'); void add.offsetWidth; add.classList.add('is-prompt');
        return;
      }
      add.disabled = true;
      add.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        add.textContent = 'Added';
        openCart();
      }).catch(function () {
        add.textContent = 'Try again';
      }).finally(function () {
        setTimeout(function () {
          add.disabled = false;
          add.textContent = 'Quick add +';
        }, 1800);
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
